module.exports = __webpack_public_path__ + "static/media/title_hankin.53d1eb7e.svg";